/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const divorcePlannerSectionStyle = {
  container: {
    textAlign: "center",
  },
  heading: {
    textAlign: "center",
  },
  subheading: {
    marginBottom: "40px",
  },
  imgPhone: {
    maxWidth: "250px",
  },
  sideText: {
    padding: "20px",
  },
  divorceImageContainer: {
    textAlign: { xs: "center", md: "right" },
  },
  text: {
    maxWidth: "250px",
    padding: "1rem",
  },
};

export default divorcePlannerSectionStyle;
